import styled from "styled-components";

export const StyledError = styled.div`
  text-align: center;
  margin-top: 40px;

  .icon {
    margin-top: 20px;
    height: 100px;
    width: 100px;
  }
`;
